import ClearableInput from '@rio-cloud/rio-uikit/components/clearableInput/ClearableInput';
import { KeyboardEvent, useCallback, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import { useDebounce } from '@/hooks/useDebounce';
import { useSendQuestionMutation } from '@/services/chatApi/chatApi';

import { SearchFieldProps } from './types';

const SearchField = ({ onSearch, shouldUseDebounce = true, shouldAutoFocus = false, onEscape }: SearchFieldProps) => {
  const intl = useIntl();
  const debouncedSearch = useDebounce(onSearch);
  const [, { isLoading: isSendMessageLoading }] = useSendQuestionMutation();
  const inputWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // INFO: Auto-focus the input when shouldAutoFocus is true (e.g. Search Control revealed)
    if (shouldAutoFocus) {
      const input = inputWrapperRef.current?.querySelector('input');
      input?.focus();
    }
  }, [shouldAutoFocus]);

  const handleKeyDown = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Escape' && onEscape) {
        e.preventDefault();
        e.stopPropagation();
        onEscape();
      }
    },
    [onEscape],
  );

  return (
    <div className="form-group padding-x-20" ref={inputWrapperRef} onKeyDown={handleKeyDown}>
      <div className="input-group">
        <span className="input-group-addon">
          <span className="rioglyph rioglyph-search" aria-hidden="true" />
        </span>
        <ClearableInput
          data-testid="thread-search-input"
          placeholder={intl.formatMessage({ id: 'chatPage.searchList.placeholder' })}
          onChange={shouldUseDebounce ? debouncedSearch : onSearch}
          disabled={isSendMessageLoading}
        />
      </div>
    </div>
  );
};

export default SearchField;
